import React from 'react';

const IconlyRegularBoldProfile = ({ width = 20, height = 20, fill = "#F04F4F" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M14.411 6.076A4.395 4.395 0 0 1 10 10.486a4.396 4.396 0 0 1-4.412-4.41A4.395 4.395 0 0 1 10 1.666a4.394 4.394 0 0 1 4.411 4.41ZM10 18.333c-3.615 0-6.667-.587-6.667-2.854 0-2.267 3.071-2.834 6.667-2.834 3.615 0 6.666.588 6.666 2.854 0 2.268-3.07 2.834-6.666 2.834Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyRegularBoldProfile;